import { useState } from "react";
import "./SaleSkipLoginPage.css";

function getCurrentLocation() {
  if (!navigator.geolocation) {
    return Promise.resolve({ latitude: null, longitude: null });
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }),
      () => resolve({ latitude: null, longitude: null }),
      {
        timeout: 8000,
        maximumAge: 0,
        enableHighAccuracy: true,
      }
    );
  });
}

export default function SaleSkipLoginPage({ apiBaseUrl, onLoginSuccess }) {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isPasswordValid = password.trim().length > 0;

  async function handleLogin(event) {
    event.preventDefault();

    if (!isPasswordValid) {
      setMessage("Please enter your password.");
      return;
    }

    setIsSubmitting(true);
    setMessage("");

    try {
      const location = await getCurrentLocation();
      if (
        typeof location.latitude !== "number" ||
        typeof location.longitude !== "number"
      ) {
        setMessage("Location access is required to login.");
        return;
      }

      const res = await fetch(`${apiBaseUrl}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          password,
          latitude: location.latitude,
          longitude: location.longitude,
        }),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setMessage(data.message || "Login failed.");
        return;
      }

      onLoginSuccess?.({
        password,
        userId: data.userId || "",
      });
    } catch (error) {
      setMessage("Could not connect to the server.");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="saleskip-login-layout">
      <section className="saleskip-left-panel">
        <div className="saleskip-pattern" aria-hidden="true" />
        <div className="saleskip-left-content">
          <p className="saleskip-tag">SMART NOTES MANAGER</p>
          <h1>Surya's Notes! 👋</h1>
          <p>
            Store, organize, and access your notes securely from anywhere.
          </p>
        </div>
      </section>

      <section className="saleskip-right-panel">
        <div className="saleskip-login-card">
          <h2>Surya&apos;s Notes</h2>
          <p className="saleskip-subtitle">
            Enter password to access notes
          </p>

          <form
            onSubmit={handleLogin}
            className="saleskip-login-form"
            autoComplete="off"
          >
            <input
              type="password"
              placeholder="Password"
              value={password}
              name="notes_access_password"
              autoComplete="new-password"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck={false}
              onChange={(event) => setPassword(event.target.value)}
              className="saleskip-input"
            />

            <button type="submit" className="saleskip-primary-btn" disabled={isSubmitting}>
              {isSubmitting ? "Logging in..." : "Login"}
            </button>
          </form>

          {message && <p className="saleskip-message">{message}</p>}
        </div>
      </section>
    </div>
  );
}
